import UrlParse from 'url-parse';

import type { TTypes, IParams, IRequiredParams } from './models';

/** Получение валидных параметров */
export const getValidParam = (val: TTypes): TTypes => {
    if (typeof val === 'boolean') return val;

    if (Number(val)) return Number(val);

    // При вызове из getParamsFromURL проверка лишена смысла, т.к. здесь и так может быть только строка
    // При вызове чистой ф-ии, у нас появляется ещё undefined из типа
    if (typeof val === 'string') {
        const lowerStr = val.toLowerCase();

        if (lowerStr === 'true') return true;
        if (lowerStr === 'false') return false;
    }

    return val;
};

/**
 * Возвращает либо все параметры из урла, либо только те, что были переданы в requiredParams
 * При наличии параметра 'requiredParams', данные value конвертируются из строк в нативные js-типы
 * Без параметра 'requiredParams' все value возвращаются только в строках
 */
export const getParamsFromURL = ({ url, requiredParams = [] }: IParams): IRequiredParams => {
    const parsedUrl = new UrlParse(url, {}, true);

    const { query } = parsedUrl;

    if (!requiredParams.length) return query;

    // Возвращает только те параметры из урла, что есть в requiredParams
    return requiredParams.reduce((acc, propName: string) => {
        if (typeof query[propName] !== 'undefined') {
            return { ...acc, [propName]: getValidParam(query[propName]) };
        }

        return acc;
    }, {});
};
